<template>
  <div class="claim-wrapper">
    <div class="new" v-if="hasStartdata">
      <div class="searchYear">
        <el-card>
          <el-form ref="form" :inline="true" label-position="left">
            <el-form-item label="数据维度">
              <el-select v-model="searchform.dimension" clearable @change="changedimension">
                <el-option label="年" value="year"></el-option>
                <el-option label="月" value="month"></el-option>
                <el-option label="日" value="day"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="统计期间" v-if="searchform.dimension == 'year'">
              <el-select v-model="searchform.year">
                <el-option v-for="(item, index) in yearArr" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="统计期间" v-if="searchform.dimension == 'month'">
              <el-date-picker
                v-model="initParam.param.startTime"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择起始月份"
                :picker-options="{
                  disabledDate: (date) => {
                    if (initParam.param.endTime) {
                      return (
                        date &&
                        (date.valueOf() > new Date(initParam.param.endTime.replace(/-/g, '/')).getTime() ||
                          date.valueOf() < startdata)
                      );
                    } else {
                      return date && (date.valueOf() > new Date() || date.valueOf() < startdata);
                    }
                  },
                }"
              ></el-date-picker>
              至
              <el-date-picker
                v-model="initParam.param.endTime"
                type="month"
                value-format="yyyy-MM"
                placeholder="选择结束月份"
                :picker-options="{
                  disabledDate: (date) => {
                    if (initParam.param.startTime) {
                      return (
                        date &&
                        (date.valueOf() > new Date() ||
                          date.valueOf() < new Date(initParam.param.startTime.replace(/-/g, '/')).getTime())
                      );
                    } else {
                      return date && (date.valueOf() > new Date() || date.valueOf() < startdata);
                    }
                  },
                }"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="统计期间" v-if="searchform.dimension == 'day'">
              <el-date-picker
                v-model="initParam.param.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择起始日期"
                :picker-options="{
                  disabledDate: (date) => {
                    if (initParam.param.endTime) {
                      return (
                        date &&
                        (date.valueOf() > new Date(initParam.param.endTime.replace(/-/g, '/')).getTime() ||
                          date.valueOf() < startdata)
                      );
                    } else {
                      return date && (date.valueOf() > new Date() || date.valueOf() < startdata);
                    }
                  },
                }"
              ></el-date-picker>
              至
              <el-date-picker
                v-model="initParam.param.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择结束日期"
                :picker-options="{
                  disabledDate: (date) => {
                    if (initParam.param.startTime) {
                      return (
                        date &&
                        (date.valueOf() > new Date() ||
                          date.valueOf() < new Date(initParam.param.startTime.replace(/-/g, '/')).getTime())
                      );
                    } else {
                      return date && (date.valueOf() > new Date() || date.valueOf() < startdata);
                    }
                  },
                }"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="统计范围">
              <el-select v-model="searchform.rangeType">
                <el-option value="0" label="全部"></el-option>
                <el-option value="1" label="员工"></el-option>
                <el-option value="2" label="弹性福利"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <i class="el-icon-warning-outline toggleicon" @click="toggleicon = !toggleicon"></i>
              <transition name="plus-icon">
                <span v-if="toggleicon">统计年度按出险时间计</span>
              </transition>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handlesearch">查询</el-button>
              <el-button type="primary" @click="handleHeader" :loading="pdfLoading" :disabled="disabled">导出</el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <p class="newclaim-tip">{{ getString() }}</p>
      <p class="newclaim-tip">本页面内容仅包含企业员工使用本平台进行在线理赔的统计数据</p>
      <div id="pdfDom">
        <div class="dataOverview">
          <div class="newclaim">
            <div  id="pdfPage1">
            <div class="scoreArea">
              <div class="healthscore" :style="{ height: 280 * barzoom + 'px' }">
                <h3>企业健康分</h3>
                <el-progress
                  type="circle"
                  :percentage="healthScore"
                  :color="'#68CAC0'"
                  :format="scoreFormat"
                  :width="120 * barzoom"
                ></el-progress>
                <p
                  class="scorePresent"
                  :style="{
                    width: 120 * barzoom + 'px',
                    height: 120 * barzoom + 'px',
                    top: 48 + 16 + 60 * barzoom + 'px',
                  }"
                >
                  <span class="present">{{ healthScore }}</span>
                  <span class="num">分</span>
                </p>
                <div class="recheck" @click="recheck" :style="{ marginTop: 23 * barzoom + 'px' }">重新检测</div>
                <p class="scoreComment">{{ healthScore > 60 ? '企业健康状况良好' : '企业健康状况较差' }}</p>
              </div>
              <div class="healthAge" :style="{ height: 280 * barzoom + 'px' }">
                <h3>在保员工年龄分布</h3>
                <cycleChat
                  :type="'age'"
                  :series="ageSeriesData"
                  :height="'280px'"
                  :width="'220px'"
                  :centerText="agetext"
                  :colorList="['#EA8D90', '#63C4C7', '#B3A3DA', '#70AFEA', '#F4BC89', '#FFDD95']"
                />
                <p class="scoreComment">{{ ageTips }}</p>
              </div>
              <div class="healthGender" :style="{ height: 280 * barzoom + 'px' }">
                <h3>在保员工男女比例</h3>
                <cycleChat
                  :series="genderSeriesData"
                  :height="'280px'"
                  :width="'220px'"
                  :centerText="gendertext"
                  :bottom="'45px'"
                  :colorList="['#B3A3DA', '#FFDD95']"
                />
                <p class="scoreComment">{{ genderTips }}</p>
              </div>
              <div class="healthclaim" :style="{ height: 280 * barzoom + 'px' }">
                <h3>平均赔付时效</h3>
                <div
                  class="claimDay"
                  :style="{
                    height: 120 * barzoom + 'px',
                    width: 120 * barzoom + 'px',
                    lineHeight: 120 * barzoom + 'px',
                  }"
                >
                  {{ searchresult.handleTime }} <span>天</span>
                </div>
                <p class="maxAmount">
                  最高赔付 <span>￥{{ searchresult.maxAmount }}</span>
                </p>
                <p class="maxAmount">
                  总理赔金额 <span>￥{{ searchresult.totalAmount }}</span>
                </p>
                <p class="caseNum">
                  总理赔 <span>{{ searchresult.caseNum }}</span
                  >件
                </p>
                <p class="scoreComment">平均赔付时效合理</p>
              </div>
            </div>
            <div class="presentArea">
              <div class="total">
                <p class="pietitle">员工就诊比例</p>
                <pie :series="seeDoctorSeriesData" :type="'staffPresent'" :colorList="['#6CD7DB', '#BDB0DE']" />
              </div>
              <div class="man">
                <el-progress
                  type="circle"
                  :percentage="manSeeDoctorPercent"
                  :format="manSeeDoctorFormat"
                  :width="150"
                  :color="'#81CFFA'"
                ></el-progress>
                <p class="coverPresent">
                  <span class="present">{{ seeDoctorData.manSeeDoctorPercent }}%</span>
                  <span class="num">{{ seeDoctorData.manSeeDoctor }}人</span>
                </p>
                <p>男性员工就诊比例</p>
              </div>
              <div class="woman">
                <el-progress
                  type="circle"
                  :percentage="womanSeeDoctorPercent"
                  :format="manSeeDoctorFormat"
                  :width="150"
                  :color="'#EC67D0'"
                ></el-progress>
                <p class="coverPresent">
                  <span class="present">{{ seeDoctorData.womanSeeDoctorPercent }}%</span>
                  <span class="num">{{ seeDoctorData.womanSeeDoctor }}人</span>
                </p>
                <p>女性员工就诊比例</p>
              </div>
            </div>
            <div class="spendArea">
              <div class="spend">
                <p class="pietitle">在线理赔申请时间</p>
                <lineChart v-if="lineXData.length" :lineXData="lineXData" :lineYData="lineYData" />

                <div class="charttips" v-else>
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
              </div>
              <div class="age">
                <p class="pietitle">在线理赔使用频次</p>
                <div class="charttips" v-if="hasNofrequency">
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
                <Nightingalecharts v-else :data="frequency" />
              </div>
            </div>
            </div>
            <div id="pdfPage2">
            <div class="illnessArea">
              <div class="num">
                <p class="pietitle">就诊次数最多的十种疾病</p>
                <revote v-if="illnessArr.length" :hospitalArr="illnessArr" :status="'illness'" />
                <div class="charttips" v-else>
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
              </div>
            </div>
            <div class="illnessArea">
              <div class="spend">
                <p class="pietitle">就诊花费最高的十种疾病</p>
                <revote v-if="spendArr.length" :hospitalArr="spendArr" :status="'spend'" :barcolor="'#59B2EB'" />
                <div class="charttips" v-else>
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
              </div>
            </div>
            <div class="spendArea">
              <div class="spend pie">
                <p class="pietitle" >金额分布</p>
                <pie
                  :series="spendSeriesData"
                  v-if="spendSeriesData.length"
                  :width="'100%'"
                  :colorList="['#F2E395','#B3A3DA', '#70AFEA ', '#F4BC89', '#63C4C7',  '#CB7F82']"
                />
                <div class="charttips" v-else>
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
              </div>
              <div class="age">
                <p class="pietitle" >年龄分布</p>
                <pie
                  :series="ageDistributedSeriesData"
                  v-if="ageDistributedSeriesData.length"
                  :width="'100%'"
                  :colorList="['#B3A3DA','#63C4C7',  '#70AFEA ', '#F4BC89', '#F2E395', '#CB7F82']"
                />
                <div class="charttips" v-else>
                  <img src="@/assets/imgs/nodata.png" alt="" />
                </div>
              </div>
            </div>
            </div>
            <div id="pdfPage3">
            <div class="hospitalArea">
              <p class="pietitle">员工偏爱的就诊医院</p>
              <treemap v-if="hospitalArr.length" :data="hospitalArr" />
              <div class="charttips" v-else>
                <img src="@/assets/imgs/nodata.png" alt="" />
              </div>
            </div>
            </div>
          </div>
          <div class="claimAnalyse"></div>
        </div>

        <div class="reportDetails" v-if="false">
          <TableToolTemp :toolListProps="{ toolTitle: '明细报表' }" @handleTool="handleTool">
            <template #tips>
              <span class="tips">包含除“待提交”外的所有状态类型数据</span>
            </template>
          </TableToolTemp>
          <el-button
            type="pain"
            @click="exportdata"
            :loading="exportloading"
            style="margin-bottom: 16px; color: #e27c00; border-color: #e27c00"
            >导出数据</el-button
          >
          <Table :data="tableData" :options="listDataOptions" align="center"></Table>
          <Pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pageData="initParam"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
          />
        </div>
      </div>
    </div>
    <div class="old" v-else>
      <old />
    </div>
  </div>
</template>
<script>
import CountTo from 'vue-count-to';
import TableToolTemp from '@/components/layouts/TableToolTemp';
import illness from './components/illness'; //疾病
import spend from './components/spend'; //花费
import gender from './components/gender'; //性别
import age from './components/age'; //年龄
import hospital from './components/hospital'; //医院
import Table from '@/components/layouts/table';
import Pagination from '@/components/layouts/Pagination';
import cycleChat from './components/cycleChat.vue';
import pie from './components/pie.vue';
import revote from './components/revote.vue';
import lineChart from '@/components/layouts/line';
import Nightingalecharts from '@/components/layouts/Nightingalecharts';
import treemap from '@/components/layouts/treemap';
import { myMixin } from '@/mixins';
import { mixins } from '@/mixins/notity.js';
import {
  selectOverviewHr,
  selectAnalysisHr,
  selectReportsHr,
  exportReportsHr,
  selectStartDateHr,
  enterprisePaidDataHrselectHealthScoreHr,
  enterprisePaidDataHrselectAnalysisHr,
  enterprisePaidDataHrselectSeeDoctorDataHr,
  selectPaidDataInfoHr,
  exportPDF,
} from '@/api/claim';
import old from './old';
import moment from 'moment';
import html2Canvas from 'html2canvas';
import JsPDF from 'jspdf';
export default {
  mixins: [myMixin, mixins],
  components: {
    CountTo,
    TableToolTemp,
    illness,
    spend,
    gender,
    age,
    hospital,
    Table,
    Pagination,
    old,
    cycleChat,
    pie,
    revote,
    lineChart,
    Nightingalecharts,
    treemap,
  },
  computed: {
    barzoom() {
      let zoom = window.devicePixelRatio;
      return 1;
    },
  },
  data() {
    return {
      htmlTitle: '员工健康报告',
      dicArr: ['gen.gender', 'bbc.claim.status', 'bbc.claim.acci.code'],
      toolListProps: {
        toolTitle: '数据概览',
      },
      claimAnalyseType: '1',
      tableData: [],
      listDataOptions: [
        { prop: 'claimNo', label: '赔案号' },
        { prop: 'claimStatus', label: '申请状态', dic: 'bbc.claim.status' },
        { prop: 'insuredName', label: '姓名', width: 100 },
        { prop: 'insuredCorrelate', label: '是否连带被保险人' },
        { prop: 'insuredSex', label: '性别', dic: 'gen.gender' },
        { prop: 'insuredAge', label: '年龄' },
        { prop: 'accidentDate', label: '出险日期' },
        { prop: 'accaddCode', label: '出险类型', dic: 'bbc.claim.acci.code' },
        { prop: 'accaddType', label: '索赔类型' },
        { prop: 'sicknessName', label: '疾病名称' },
        { prop: 'hospitalName', label: '就诊医院' },
        { prop: 'invoiceValue', label: '申请金额' },
        { prop: 'compensateAmount', label: '赔付金额' },
        { prop: 'handleTime', label: '赔付时效（天）' },
      ],
      total: 0,
      searchresult: {},
      searchform: {
        dimension: 'year', //数据维度
        year: new Date().getFullYear(),
        month: '',
        day: '',
        rangeType: '0',
      },
      illnessArr: [], //疾病数据
      spendArr: [], //花费数据
      genderArr: [], //性别数据
      ageArr: [], //年龄数据
      hospitalArr: [], //医院数据
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          startTime: new Date().getFullYear() + '-01-01',
          endTime: new Date().getFullYear() + '-12-31',
        },
      },
      copyparam: {
        startTime: '',
        endTime: '',
      },
      hasclicksearchbtn: false,
      hasStartdata: false,
      startdata: null,
      startMonth: null,
      yearArr: [],
      nodata: true,
      exportloading: false,
      toggleicon: false,
      healthScore: 0,
      ageSeriesData: [], //在保员工年龄分布
      genderSeriesData: [], //再报员工性别比例
      ageTips: '',
      genderTips: '',
      seeDoctorSeriesData: [], // 员工就诊比例
      manSeeDoctorPercent: 0,
      womanSeeDoctorPercent: 0,
      spendSeriesData: [], //金额分布
      ageDistributedSeriesData: [], //年龄分布
      agetext: '', //平均年龄
      gendertext: '',
      seeDoctorData: {},
      headerPoster: require('@/assets/imgs/report.png'),
      // 1.9.3新增
      applyObj: {},
      lineXData: [],
      lineYData: [],
      frequency: [],
      hasNofrequency: true,
      pdfLoading: true,
      disabled:true,
    };
  },
  methods: {
    handleTool(item) {},
    async init() {
      await this.getyearArr();
      this.selectHealthScoreHr();
      // await this.queryData();
      this.dataOverview();
      // await this.Analysis();
      this.PaidDataHrselectSeeDoctorDataHr();
      this.PaidDataHrselectAnalysisHr(); //后五个
      this.handleSelectPaidDataInfoHr();
      setTimeout(()=>{
        this.disabled = false
      },3000)
    },
    async queryData(bool = true) {
      if (bool) this.initParam.pageNum = 1;
      try {
        let param = {
          startTime: this.initParam.param.startTime
            ? this.initParam.param.startTime.length == 10
              ? this.initParam.param.startTime
              : this.initParam.param.startTime + '-01'
            : '',
          endTime: this.initParam.param.endTime
            ? this.initParam.param.endTime.length == 10
              ? this.initParam.param.endTime
              : this.initParam.param.endTime + '-31'
            : '',
        };

        let res = await selectReportsHr({ ...this.initParam, param });
        if (res && res.list && res.list.length) {
          this.tableData = res.list.map((item) => {
            item.invoiceValue = item.invoiceValue > 0 ? '￥' + item.invoiceValue : item.invoiceValue;
            let compensateStatus = item.compensateStatus;
            item.compensateAmount =
              compensateStatus == 1
                ? item.compensateAmount > 0
                  ? '￥' + item.compensateAmount
                  : item.compensateAmount
                : '--';
            return item;
          });
          this.total = res.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
      } catch (err) {}
    },
    async dataOverview() {
      try {
        let param = {
          rangeType: this.searchform.rangeType,
          startTime: this.initParam.param.startTime
            ? this.initParam.param.startTime.length == 10
              ? this.initParam.param.startTime
              : this.initParam.param.startTime + '-01'
            : '',
          endTime: this.initParam.param.endTime
            ? this.initParam.param.endTime.length == 10
              ? this.initParam.param.endTime
              : this.initParam.param.endTime + '-31'
            : '',
        };
        let res = await selectOverviewHr({ ...param });

        if (res) {
          this.searchresult = res;
        }
      } catch (err) {}
    },
    // 赔付分析
    async Analysis(obj) {
      try {
        let param;
        if (obj) {
          param = {
            startTime: obj.startTime ? (obj.startTime.length == 10 ? obj.startTime : obj.startTime + '-01') : '',
            endTime: obj.endTime ? (obj.endTime.length == 10 ? obj.endTime : obj.endTime + '-31') : '',
          };
        } else {
          param = {
            startTime: this.initParam.param.startTime
              ? this.initParam.param.startTime.length == 10
                ? this.initParam.param.startTime
                : this.initParam.param.startTime + '-01'
              : '',
            endTime: this.initParam.param.endTime
              ? this.initParam.param.endTime.length == 10
                ? this.initParam.param.endTime
                : this.initParam.param.endTime + '-31'
              : '',
          };
        }
        let res = await selectAnalysisHr({ ...param, analysisType: this.claimAnalyseType });
        let flag = res.length;
        if (res && Array.isArray(res)) {
          if (this.claimAnalyseType == 1) {
            this.illnessArr = res;
            this.nodatacheck(flag);
          }
          if (this.claimAnalyseType == 2) {
            this.spendArr = res;
            this.nodatacheck(flag);
          }
          if (this.claimAnalyseType == 3) {
            this.genderArr = res;
            this.nodatacheck(flag);
          }
          if (this.claimAnalyseType == 4) {
            this.ageArr = res;
            this.nodatacheck(flag);
          }
          if (this.claimAnalyseType == 5) {
            this.hospitalArr = res;
            this.nodatacheck(flag);
          }
        }
      } catch (err) {}
    },
    nodatacheck(data) {
      if (data > 0) {
        this.nodata = false;
      } else {
        this.nodata = true;
      }
    },
    async handlesearch() {
      this.hasclicksearchbtn = true;
      if (this.searchform.dimension == 'year') {
        let startTime = this.searchform.year;
        if (startTime) {
          if (+new Date(startTime + '-12-31 23:59:59') >= +new Date()) {
            this.initParam.param = {
              startTime: startTime + '-01-01',
              endTime: moment(new Date()).format('YYYY-MM-DD'),
            };
          } else {
            this.initParam.param = {
              startTime: startTime + '-01-01',
              endTime: startTime + '-12-31',
            };
          }
        }
      } else if (this.searchform.dimension == 'month') {
        // 如果开始日期或者结束日期 就必须都填
        let startTime = this.initParam.param.startTime;
        let endTime = this.initParam.param.endTime;
        if (startTime && endTime) {
        } else {
          this.$message({
            message: startTime ? '请选择结束月份' : '请选择开始月份',
            type: 'warning',
          });
          return;
        }
      } else {
        let startTime = this.initParam.param.startTime;
        let endTime = this.initParam.param.endTime;
        if (startTime && endTime) {
        } else {
          this.$message({
            message: startTime ? '请选择结束日期' : '请选择开始日期',
            type: 'warning',
          });
          return;
        }
      }

      this.disabled = true
      // 1.4.1
      this.selectHealthScoreHr();
      this.dataOverview();
      this.PaidDataHrselectSeeDoctorDataHr();
      this.PaidDataHrselectAnalysisHr(); //后五个
      this.handleSelectPaidDataInfoHr();
      setTimeout(() => {
        this.disabled = false
      }, 3000);
    },
    handleclaimAnalyseType(data) {
      // 没点过查询按钮

      this.Analysis(this.hasclicksearchbtn ? this.copyparam : '');
    },
    monthadd0(data) {
      return data >= 10 ? data : '0' + data;
    },
    async exportdata() {
      this.exportloading = true;
      let param = {
        startTime: this.initParam.param.startTime
          ? this.initParam.param.startTime.length == 10
            ? this.initParam.param.startTime
            : this.initParam.param.startTime + '-01'
          : '',
        endTime: this.initParam.param.endTime
          ? this.initParam.param.endTime.length == 10
            ? this.initParam.param.endTime
            : this.initParam.param.endTime + '-31'
          : '',
      };
      exportReportsHr('赔付数据.xlsx', param).then((res) => {
        this.exportloading = false;
      });
    },
    async getyearArr() {
      let res = await selectStartDateHr({});
      // if (res && typeof res == 'number') {
      if (res ) {
        this.hasStartdata = true;
        this.startdata = res;
        let startYear = new Date(res).getFullYear();
        let nowYear = new Date().getFullYear();
        let startMonth = new Date(res).getMonth() + 1;
        this.startMonth = startMonth;
        let arr = [],
          a = startYear;
        for (let i = 0; i <= nowYear - startYear; i++) {
          arr.push(a);
          a++;
        }
        this.yearArr = arr.length ? arr : [nowYear];
      }
    },
    changedimension(data) {
      if (data == 'year') {
      } else {
        this.initParam.param.startTime = '';
        this.initParam.param.endTime = '';
      }
    },
    //14.1改版新增 企业健康分
    async selectHealthScoreHr() {
      let param = this.getparams();
      let res = await enterprisePaidDataHrselectHealthScoreHr(param);

      if (res) {
        this.healthScore = res * 1;
      }
    },
    scoreFormat(percentage) {
      // return percentage + '分';
      return '';
    },
    manSeeDoctorFormat() {
      return '';
    },
    recheck() {
      this.healthScore = 0;

      this.selectHealthScoreHr();
    },
    getparams() {
      let param = {
        startTime: this.initParam.param.startTime
          ? this.initParam.param.startTime.length == 10
            ? this.initParam.param.startTime
            : this.initParam.param.startTime + '-01'
          : '',
        endTime: this.initParam.param.endTime
          ? this.initParam.param.endTime.length == 10
            ? this.initParam.param.endTime
            : this.initParam.param.endTime + '-31'
          : '',
        enterpriseId: this.$store.state.user.user.enterpriseId,
        rangeType: this.searchform.rangeType,
      };
      return param;
    },
    async PaidDataHrselectAnalysisHr() {
      let param = this.getparams();
      let res = await enterprisePaidDataHrselectAnalysisHr(param);
      if (res) {
        this.spendArr = res.CLAIM_ANALYSIS_COST;
        this.illnessArr = res.CLAIM_ANALYSIS_SICK;
        this.spendSeriesData =
          res.CLAIM_ANALYSIS_SPEND[0].totalNum == 0
            ? []
            : [
                { value: res.CLAIM_ANALYSIS_SPEND[0]['300yuan'], name: '<=300元' },
                { value: res.CLAIM_ANALYSIS_SPEND[0]['800yuan'], name: '300-800元' },
                { value: res.CLAIM_ANALYSIS_SPEND[0]['1500yuan'], name: '800-1500元' },
                { value: res.CLAIM_ANALYSIS_SPEND[0]['3000yuan'], name: '1500-3000元' },
                { value: res.CLAIM_ANALYSIS_SPEND[0]['4000yuan'], name: ' >3000元' },
              ];
        this.ageDistributedSeriesData =
          res.CLAIM_ANALYSIS_AGE[0].totalNum == 0
            ? []
            : [
                { value: res.CLAIM_ANALYSIS_AGE[0]['post60s'], name: '60后' },
                { value: res.CLAIM_ANALYSIS_AGE[0]['post70s'], name: '70后' },
                { value: res.CLAIM_ANALYSIS_AGE[0]['post80s'], name: '80后' },
                { value: res.CLAIM_ANALYSIS_AGE[0]['post90s'], name: '90后' },
                { value: res.CLAIM_ANALYSIS_AGE[0]['post00s'], name: '00后' },
                { value: res.CLAIM_ANALYSIS_AGE[0]['postOthers'], name: '其他' },
              ];
        let treemapColor = ["#5A79C0", "#6698E3", "#47B0B4", "#63C4C7", "#A58EDE ", "#EA8D90", "#F4BC89", "#EB9BE0", "#EEC472", "#F2E395 "];
        this.hospitalArr = res.CLAIM_ANALYSIS_HOS.map((item,index) => {
          item.name = item.hospitalName;
          item.value = item.hospitalNum;
          item.itemStyle = {
            color: treemapColor[index],
          };
          return item;
        });
      }
    },
    async PaidDataHrselectSeeDoctorDataHr() {
      let param = this.getparams();
      let res = await enterprisePaidDataHrselectSeeDoctorDataHr(param);
      if (res) {
        this.ageTips = res.avgAge <= 35 ? '企业朝气蓬勃' : res.avgAge > 45 ? '企业厚积薄发' : '企业风华正茂';
        this.agetext = res.avgAge ? '平均年龄' + res.avgAge + '岁' : '';
        this.gendertext = '男' + res.man + '人' + '女' + res.woman + '人';
        this.genderTips = this.getgenderTips(res.man, res.woman, res.insureds);
        this.ageSeriesData = [
          { value: res.post60s, name: '60后(' + this.getpresent(res.post60s, res.insureds) + ')' },
          { value: res.post70s, name: '70后(' + this.getpresent(res.post70s, res.insureds) + ')' },
          { value: res.post80s, name: '80后(' + this.getpresent(res.post80s, res.insureds) + ')' },
          { value: res.post90s, name: '90后(' + this.getpresent(res.post90s, res.insureds) + ')' },
          { value: res.post00s, name: '00后(' + this.getpresent(res.post00s, res.insureds) + ')' },
          { value: res.postOthers, name: '其他(' + this.getpresent(res.postOthers, res.insureds) + ')' },
        ];
        this.genderSeriesData = [
          { value: res.man, name: '男(' + this.getpresent(res.man, res.insureds) + ')' },
          { value: res.woman, name: '女(' + this.getpresent(res.woman, res.insureds) + ')' },
        ];
        this.seeDoctorSeriesData = [
          { value: res.healthInsureds, name: '健康', datas: `(${res.healthInsuredsPercent}%)身体健康` },
          {
            value: res.totalSeeDoctorNums,
            name: '就诊',
            datas: `(${res.totalSeeDoctorPercent}%)曾有就诊行为,累计就诊${res.totalSeeDoctorTimes}次`,
          },
        ];
        this.manSeeDoctorPercent = res.manSeeDoctorPercent;
        this.womanSeeDoctorPercent = res.womanSeeDoctorPercent;
        this.seeDoctorData = res;
      }
    },
    getpresent(value, arr) {
      if (arr == 0) return 0;
      if (value / arr == 1) return '100%';
      let str = String((value / arr).toFixed(2)).split('.')[1];
      str = str[0] == 0 ? str[1] : str;
      return arr == 0 ? 0 : str + '%';
    },
    getgenderTips(man, woman, insureds) {
      let manPresent = (man / insureds).toFixed(2) * 100;
      let womanPresent = (woman / insureds).toFixed(2) * 100;
      let absNum = Math.abs(manPresent - womanPresent);
      if (absNum <= 15) {
        return '性别比例均衡';
      } else {
        return manPresent > womanPresent ? '手揽山河，气吞日月' : '巾帼不让须眉';
      }
    },
    // 1.9.3 需求
    async handleSelectPaidDataInfoHr() {
      let param = this.getparams();
      let res = await selectPaidDataInfoHr(param);
      let arr = [];
      res.apply &&
        Object.keys(res.apply).map((key) => {
          arr.push({
            key: key,
            value: res.apply[key],
          });
        });
      arr.length && (arr = arr.sort((a, b) => +new Date(a.key) - +new Date(b.key)));

      this.lineXData = arr.length ? arr.map((item) => item.key) : [];
      this.lineYData = arr.length ? arr.map((item) => item.value) : [];
      const result = { ...res.frequency };
      let num = 0;
      Object.keys(result).forEach((key) => {
        const value = result[key];
        if (value === 0) {
          num++;
          // delete result[key];
          result[key] = '';
        }
      });
      if (num < 6) {
        this.hasNofrequency = false;
      } else {
        this.hasNofrequency = true;
      }
      let keyMap = {
        frequency1to5: '1-5次',
        frequency6to10: '6-10次',
        frequency11to15: '11-15次',
        frequency16to20: '16-20次',
        frequency21to25: '21-25次',
        frequency25Over: '25次以上',
      };
      this.frequency = res.frequency
        ? Object.keys(result).map((key) => {
            return {
              name: keyMap[key],
              value: result[key],
            };
          })
        : [];
      this.pdfLoading = false;
    },
    handleHeader() {
     this.$sa('welfareHRClaimsDataElementClick',{
        '$element_name':'导出'
      })
    let pageArray = [];
    let pageHeight1 = document.querySelector('#pdfPage2').offsetTop - document.querySelector('#pdfPage1').offsetTop;
    let pageHeight2 = document.querySelector('#pdfPage3').offsetTop - document.querySelector('#pdfPage2').offsetTop;
    let pageHeight3 = document.querySelector('#pdfDom').offsetHeight - pageHeight1 - pageHeight2;
    pageArray.push(pageHeight1);
    pageArray.push(pageHeight2);
    pageArray.push(pageHeight3);

      this.pdfLoading = true;
      let that = this;
      html2Canvas(document.querySelector('#pdfDom'), {
        allowTaint: true,
      }).then((element) => {
        let dataURL = element.toDataURL('image/jpeg');
        let formDate = new FormData();
        let file = that.dataURLtoFile(dataURL, '健康报告');

        formDate.append('file', file);
        formDate.append('pageHight', pageArray);
        formDate.append('enterpriseName', that.$store.state.user.user.enterpriseName);
        formDate.append(
          'time',
          that.searchform.dimension == 'year'
            ? that.searchform.year + '年'
            : that.initParam.param.startTime + '至' + that.initParam.param.endTime
        );

        exportPDF(formDate)
          .then((res) => {})
          .finally(() => {
            this.pdfLoading = false;
          });
      });
    },
    /**该方法用来绘制一个有填充色的圆角矩形
     *@param cxt:canvas的上下文环境
     *@param x:左上角x轴坐标
     *@param y:左上角y轴坐标
     *@param width:矩形的宽度
     *@param height:矩形的高度
     *@param radius:圆的半径
     *@param fillColor:填充颜色
     **/
    fillRoundRect(cxt, x, y, width, height, radius, /*optional*/ fillColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }

      cxt.save();
      cxt.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius);
      if (Array.isArray(fillColor)) {
        var my_gradient = cxt.createLinearGradient(0, 0, 0, height); //从上到下
        my_gradient.addColorStop(0, fillColor[0]);
        my_gradient.addColorStop(1, fillColor[1]);
        cxt.fillStyle = my_gradient;
      } else {
        cxt.fillStyle = fillColor || '#000'; //若是给定了值就用给定的值否则给予默认值
      }

      cxt.fill();
      cxt.restore();
    },
    /**该方法用来绘制圆角矩形
     *@param cxt:canvas的上下文环境
     *@param x:左上角x轴坐标
     *@param y:左上角y轴坐标
     *@param width:矩形的宽度
     *@param height:矩形的高度
     *@param radius:圆的半径
     *@param lineWidth:线条粗细
     *@param strokeColor:线条颜色
     **/
    strokeRoundRect(cxt, x, y, width, height, radius, /*optional*/ lineWidth, /*optional*/ strokeColor) {
      //圆的直径必然要小于矩形的宽高
      if (2 * radius > width || 2 * radius > height) {
        return false;
      }

      cxt.save();
      cxt.translate(x, y);
      //绘制圆角矩形的各个边
      this.drawRoundRectPath(cxt, width, height, radius);
      cxt.lineWidth = lineWidth || 2; //若是给定了值就用给定的值否则给予默认值2
      cxt.strokeStyle = strokeColor || '#000';
      cxt.stroke();
      cxt.restore();
    },
    drawRoundRectPath(cxt, width, height, radius) {
      cxt.beginPath(0);
      //从右下角顺时针绘制，弧度从0到1/2PI
      cxt.arc(width - radius, height - radius, radius, 0, Math.PI / 2);

      //矩形下边线
      cxt.lineTo(radius, height);

      //左下角圆弧，弧度从1/2PI到PI
      cxt.arc(radius, height - radius, radius, Math.PI / 2, Math.PI);

      //矩形左边线
      cxt.lineTo(0, radius);

      //左上角圆弧，弧度从PI到3/2PI
      cxt.arc(radius, radius, radius, Math.PI, (Math.PI * 3) / 2);

      //上边线
      cxt.lineTo(width - radius, 0);

      //右上角圆弧
      cxt.arc(width - radius, radius, radius, (Math.PI * 3) / 2, Math.PI * 2);

      //右边线
      cxt.lineTo(width, height - radius);
      cxt.closePath();
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },
    getString() {
      let enterpriseName = this.$store.state.user.user.enterpriseName;
      let during = '';
      if (this.searchform.dimension == 'year') {
        during = this.searchform.year + '年';
      } else {
        during = this.initParam.param.startTime + '至' + this.initParam.param.endTime;
      }
      return enterpriseName + '' + during;
    },
  },
};
</script>
<style lang="less" scoped>
.claim-wrapper {
  max-width: 1200px;
  margin: 0 auto;
}
.reportBanner {
  width: 100%;
  height: 300px;
}
.text-center {
  text-align: center;
  &.num {
    padding-bottom: 10px;

    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #e27c00;
  }
}
.tips {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaf;
  line-height: 16px;
}
.searchYear {
  margin: 0 30px 20px;
}
.dataOverview {
  .dataOverview-desc {
    background: #fffdfa;
    border: 1px solid #dcdce1;
    // padding: 32px 50px;
    padding: 32px 0px;
    margin-bottom: 40px;
  }
}
.Analysedesc {
  // background:rgba(220, 220, 225, 1);
  border: 1px solid #dcdce1;
  // padding: 32px 50px;
  margin-bottom: 40px;
  padding: 40px;
}
.toggleicon {
  color: #e27c00;
  font-size: 18px;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 10px;
}
.plus-icon-enter-active {
  transition: opacity 0.5s linear;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s linear;
}
.plus-icon-leave-to {
  opacity: 0;
}
.newclaim-tip {
  text-align: center;
  padding: 6px 0 16px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #aaaaaf;
  line-height: 16px;
  &:last-of-type {
    padding-top: 0;
  }
}
.newclaim {
  .scoreArea {
    display: flex;
    .healthscore,
    .healthAge,
    .healthGender,
    .healthclaim {
      background: #fff;
      flex: 1;
      // height: 340px;
      margin-right: 18px;
      // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      padding-bottom: 40px;
      .scorePresent {
        // width: 150px;
        // height: 150px;
        position: absolute;
        left: 50%;
        // top: 35%;
        transform: translate(-50%, -50%);
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        .present {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #55555a;
          line-height: 32px;
        }
        .num {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #55555a;
          line-height: 14px;
          margin-top: 10px;
        }
      }
      h3 {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #382e2b;
        line-height: 16px;
        margin: 24px 0;
      }
      .recheck {
        // margin-top: 23px;
        height: 32px;
        line-height: 32px;
        width: 88px;
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #35d6a0;
        border-radius: 18px;
        border: 1px solid #35d6a0;
        cursor: pointer;
      }
      .scoreComment {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #aaaaaf;
        text-align: center;
        position: absolute;
        bottom: 26px;
        width: 100%;
        text-align: center;
      }
      .claimDay {
        height: 120px;
        width: 120px;
        background: linear-gradient(180deg, #439eac 0%, #84f0da 100%);
        border-radius: 100%;
        margin: 0 0 10px 0;
        text-align: center;
        line-height: 120px;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        span {
          font-size: 12px;
        }
      }
      .maxAmount {
        margin-bottom: 10px;

        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #55555a;
        span {
          color: #e27c00;
        }
        &:first-of-type {
          margin-top: 5px;
        }
      }
      .caseNum {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        //  margin-top: 5px;
        color: #55555a;
        span {
          color: #e27c00;
        }
      }
    }
    .healthclaim {
      margin-right: 0;
    }
    .healthAge,
    .healthGender {
      h3 {
        margin-bottom: 0;
      }
    }
  }
  .presentArea {
    background: #fff;
    margin: 20px 0;
    display: flex;
    padding-top: 25px;
    // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    .total {
      width: 50%;
      // padding-bottom: 30px;
      .pietitle {
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #382e2b;
      }
    }
    .man,
    .woman {
      flex: 0 0 25%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      position: relative;
      p {
        margin-top: 14px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #382e2b;
      }
      .coverPresent {
        width: 150px;
        height: 150px;
        position: absolute;
        left: 50%;
        top: 45%;
        transform: translate(-50%, -50%);
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .present {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #55555a;
          line-height: 32px;
        }
        .num {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #55555a;
          line-height: 14px;
          margin-top: 10px;
        }
      }
    }
  }
  .illnessArea {
    background: #fff;
    display: flex;
    // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 30px;
    margin-bottom: 20px;
    .num,
    .spend {
      flex: 1;
      .pietitle {
        text-align: center;
        margin: 0 0 30px 0;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #382e2b;
      }
    }
  }
  .spendArea {
    background: #fff;
    display: flex;
    // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 30px 0 0px;
    margin-bottom: 20px;
    .pietitle {
      text-align: center;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #382e2b;
      // width: 460px;
    }
    .spend{
      flex:0 0  700px ;
      &.pie{
        flex:1;
      }
    }
    .age {
      flex: 1;
    }
  }
  .hospitalArea {
    background: white;
    // box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
    border-radius: 10px;
    padding: 30px 0 10px;
    .pietitle {
      text-align: center;
      margin: 0 0 30px 0;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #382e2b;
    }
  }
}
/deep/.el-progress--circle .el-progress__text,
.el-progress--dashboard .el-progress__text {
  font-size: 32px;
}
#pdfDom {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 30px;
  background: #f5f5f5;
}
</style>